const contentfulFallback = {
  CANCEL_BUTTON: "Close",
  COMPANY_LABEL: "Company",
  CONTINUE_BUTTON: "Continue",
  CONTINUE_TO_PRODUCT_BUTTON: "Continue to {{productName}}",
  DESCRIPTION_TEXT: "Tailor your experience with Autodesk based on the work that you do.",
  ERROR_MESSAGE_GENERIC: "An error occurred, please try again later.",
  HEADER_TEXT: "Update your profile information",
  INDUSTRY_LABEL: "Industry",
  PRIVACY_LINK_TEXT: "Privacy Statement",
  ROLE_LABEL: "Role",
  SAVE_BUTTON: "Save",
  SUCCESS_MESSAGE: "You can view and edit your information at any time in your <0>profile</0>.",
  SUCCESS_TITLE: "Information saved",
  WELCOME_MESSAGE: "Hi, {{firstName}} {{lastName}}"
};

export default contentfulFallback;
